import Keycloak from 'keycloak-js';

const keycloakSettings = {
    url: process.env.VUE_APP_BASE_KEYCLOAK_URL,
    // realm: 'microservices-realm',
    realm: 'backoffice-realm',
    clientId: 'admin-react-app'
};

const _kc = new Keycloak(keycloakSettings);

const doLogin = _kc.login;

const doLogout = _kc.logout;

const getToken = () => _kc.token;

// const updateToken = (successCallback) =>
//     _kc.updateToken().then(successCallback).catch(doLogin);

const updateToken = (successCallback) =>
    _kc.updateToken(5)
        .then(successCallback)
        .catch(() => _kc.login());

const hasRole = (roles) => roles.some((role) => _kc.hasRealmRole(role));

const ownerName = () => {
    return _kc.tokenParsed.preferred_username;
};

const userRoles = () => {
    return _kc.tokenParsed.realm_access.roles;
};

function initKeycloak(authCallback) {
    let roles = [
        'ROLE_ADMIN',
        'ROLE_ACCOUNTANT',
        'ROLE_MANAGER',
        'ROLE_SUPPORT',
        'ROLE_BSR_MODERATOR',
        'ROLE_READONLY',
        'ROLE_AGENT',
    ];

    _kc.init({
        onLoad: 'login-required'
    }).then((auth) => {
        if (auth) {
            localStorage.setItem('token', getToken());
            if (hasRole(roles)) {
                authCallback();
            } else {
                doLogout();
            }
        } else {
            console.log('Not Authenticated');
            doLogin();
        }
    });
}

const KeycloakService = () => {
    return {
        initKeycloak,
        doLogin,
        doLogout,
        getToken,
        updateToken,
        hasRole,
        ownerName,
        userRoles
    };
};

export default KeycloakService;
